<template>
    <div class="grid grid-cols-4 gap-2">
        <template v-for="(item, idx) of tabs" :key="`item-${idx}`">
            <SearchBarTypeItem v-bind="item" :active="isActive(item)" @click="selectType(item)">
                <img :src="item.img" alt=""/>
            </SearchBarTypeItem>
        </template>
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import SearchBarTypeItem from './SearchBarTypeItem.vue';
import { useTracking } from "@/feature/TrackingFeature";

export default defineComponent({
    props: {
        modelValue: {
            type: String
        }
    },
    emits: ["update:modelValue"],
    setup: function (props, ctx) {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()
        const tabs = [
            { label: "อู่ซ่อมรถ", img: require("@/assets/icon/searchbar/ic-searchbar-garage.svg"), value: "G" },
            { label: "ศูนย์บริการ", img: require("@/assets/icon/searchbar/ic-searchbar-service.svg"), value: "D" },
            { label: "ร้านกระจก", img: require("@/assets/icon/searchbar/ic-searchbar-glass-shop.svg"), value: "W" },
            { label: "โรงพยาบาล", img: require("@/assets/icon/searchbar/ic-searchbar-hospital.svg"), value: "H" },
        ]
        const inputValue = computed({
            get: function () {
                return props.modelValue
            },
            set: function (val) {
                ctx.emit("update:modelValue", val)
            }
        })

        const isActive = function (item) {
            if (inputValue.value == item.value) {
                return true
            }

            return false
        }

        const selectType = function (item) {
            tracking.event("search_page", "click_catagories", item.value , "");
            inputValue.value = item.value
        }

        return {
            inputValue,
            tabs,
            isActive,
            selectType
        }
    },
    components: { SearchBarTypeItem }
})
</script>


